import axios from "axios"
import {
  ReactElement,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react"
import { Dispatch, SetStateAction } from "react"

interface IAuthContext {
  token: string | null
  setToken: Dispatch<SetStateAction<string>>
}

const authContextDefaultValues: IAuthContext = {
  token: null,
  setToken: () => {},
}

const AuthContext = createContext<IAuthContext>(authContextDefaultValues)

const AuthProvider = ({ children }: { children: ReactElement }) => {
  // state to hold the authentication token
  const [token, setToken_] = useState(localStorage.getItem("token"))

  // function to set the authentication token
  const setToken = (newToken: any) => {
    setToken_(newToken)
  }

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token
      localStorage.setItem("token", token)
    } else {
      delete axios.defaults.headers.common["Authorization"]
      localStorage.removeItem("token")
    }
  }, [token])

  // memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
    }),
    [token]
  )

  // provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}

export const useAuth = () => {
  return useContext(AuthContext)
}

export default AuthProvider
